import OlExtElement from 'ol-ext/util/element'

export function createButton (html, onClick) {
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.innerHTML = html
  btn.addEventListener('click', onClick)
  return btn
}

export function createInteractiveHelp (options = {}) {
  const {
    title = 'aide',
    buttonTitle = 'Afficher / Masquer l\'aide',
    helpTexts = [],
    joinText = '',
  } = options
  const helpTitle = OlExtElement.create('DIV', {
    className: 'help-tile',
    html: `<div>${title}</div>`,
  })
  const helpButton = OlExtElement.create('I', {
    className: 'kmapv-icon xs kmapv-icon-question kmapv-icon-circle',
  })
  helpButton.setAttribute('title', buttonTitle)

  helpTitle.addEventListener('click', function () {
    helpDiv.classList.toggle('kmapv-icon-expanded')
    helpButton.classList.toggle('kmapv-icon-question')
    helpButton.classList.toggle('kmapv-icon-circle')
    helpButton.classList.toggle('kmapv-icon-cancel')
  })

  helpTitle.appendChild(helpButton)
  const helpDiv = OlExtElement.create('DIV', {
    className: 'kmapv-collapsible',
    html: '<div class="help">' + helpTexts.join(joinText) + '</div>',
  })

  // insérer dans le l'élément helpTile puis helpDiv
  return {
    helpTitle,
    helpDiv,
  }
}

export default {
  createButton,
  createInteractiveHelp,
}
